// extracted by mini-css-extract-plugin
module.exports = {"container":"_1YxnY","wrapper":"TLtvA","tabsNavigation":"c1lk0","tab":"_1yaVH","tabContent":"_2gebT","deliveryDetails":"_1jAgc","deliveryDetailsContent":"_2YO9v"};